"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var tslib_1 = require("tslib");
/**
 * An error representing a failure of an individual credential provider.
 *
 * This error class has special meaning to the {@link chain} method. If a
 * provider in the chain is rejected with an error, the chain will only proceed
 * to the next provider if the value of the `tryNextLink` property on the error
 * is truthy. This allows individual providers to halt the chain and also
 * ensures the chain will stop if an entirely unexpected error is encountered.
 */


var ProviderError =
/** @class */
function (_super) {
  tslib_1.__extends(ProviderError, _super);

  function ProviderError(message, tryNextLink) {
    if (tryNextLink === void 0) {
      tryNextLink = true;
    }

    var _this = _super.call(this, message) || this;

    _this.tryNextLink = tryNextLink;
    return _this;
  }

  return ProviderError;
}(Error);

exports.ProviderError = ProviderError;